import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CoordinatesModel } from 'src/app/models/coord-dms';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { NavaidFromMapService } from 'src/app/services/navaid-from-map.service';

@Component({
  selector: 'app-coordinates',
  templateUrl: './coordinates.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CoordinatesComponent implements OnInit {

  coordinatesModel : CoordinatesModel;
  public onClose: Subject<boolean>;
  constructor(private bsModalRef : BsModalRef, private navaidFromMapService : NavaidFromMapService) {
  }

  ngOnInit(): void {
    this.onClose = new Subject();
    this.coordinatesModel = new CoordinatesModel();
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelCoordinates(false); // escape key already hides the modal
  }

  cancelCoordinates(hideModal: boolean = true) : void{
    this.onClose.next(false);
    hideModal? this.bsModalRef.hide(): false;
  }

  saveCoordinates() : void{
    this.navaidFromMapService.navaidFromMapModel.latitude = this.coordinatesModel.latitude;
    this.navaidFromMapService.navaidFromMapModel.longitude = this.coordinatesModel.longitude;
    this.navaidFromMapService.navaidFromMapModel.latLonDms = this.coordinatesModel.latLonDms;
    this.onClose.next(true);
    this.bsModalRef.hide();
  }
}
